const secondCircleList = ['#2A1673', '#572DF3', '#4122B3', '#4F29D9'];

export { secondCircleList };
